<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Your file</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        
        <v-divider></v-divider>
        <!-- <object :data='document' 
        type='application/pdf' 
        width='100%' 
        height='700px'> -->
        <iframe :src="document" 
          style="width:100vw; height:100vh;" frameborder="0"></iframe>
        <!-- <pdf :src="document" :page="1"></pdf> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

//import pdf from 'vue-pdf'
//import pdf from "pdfvuer"
export default {
  components: {
    //pdf
  },
  data: () => ({
    document: "",
    dialog: false,
  }),
  methods: {
    openDialog(filepath) {
    if (filepath.includes("https://api.mi-sos.org/uploads")) {
      console.log("this")
      this.document = filepath
    } else {
      this.document = "https://api.mi-sos.org/uploads/" + filepath
    }
      this.dialog =  true
    }
  }
}
</script>

<style>

</style>